import styled, { css } from 'styled-components';
import { Ellipsis } from '@simplywallst/ui-core';
import { media } from '@simplywallst/ui-core';

export interface Props {
  isSticky: boolean;
}

export const Wrapper = styled('section')`
  position: relative;
`;

export const TableHead = styled('thead')`
  white-space: nowrap;
  th {
    position: sticky;
    background: ${({ theme }) => theme.color.charcoal} !important;
    > svg {
      cursor: help;
      display: inline-block;
      margin-bottom: -8px;
      margin-top: -8px;
      margin-right: -8px;
      > * {
        fill: ${({ theme }) => theme.color.whiteRGBA(0.5)};
      }
    }
  }
`;

export const SkeletonRow = styled('tr')`
  > td > span {
    display: block;
    cursor: auto !important;
  }
  &:hover {
    > td {
      background: transparent !important;
    }
  }
  &:active {
    > td {
      background: transparent !important;
    }
  }
`;

export const NameColumnHeader = styled('th')<Props>`
  width: 116px;
  ${media.mdDown`
    left: -1px;
    z-index: 1;
    border-right: ${({ isSticky, theme }) =>
      isSticky ? `1px solid ${theme.color.whiteRGBA(0.1)} !important` : 'none'};
    ${({ isSticky }) => isSticky && `width: 95px;`}
	`};
`;

export const SnowflakeColumnHeader = styled('th')`
  height: 55px;
  ${media.mdDown`
    width: ${({ theme }) => theme.x9spacePx}px;
  `}
  width: ${({ theme }) => theme.x7spacePx}px;
`;

export const SnowflakeColumn = styled('td')`
  width: ${({ theme }) => theme.x9spacePx}px;
  ${media.lgUp`
    width: ${({ theme }) => theme.x7spacePx}px;
  `}
`;

export const NameColumn = styled('td')<Props>`
  ${media.mdDown`
    position: sticky;
    left: -1px;
    z-index: 1;
    background: ${({ theme }) => theme.color.charcoal} !important;
    ${({ isSticky }) => isSticky && `width: 95px;`}
    ${({ isSticky }) =>
      isSticky &&
      css`
        box-shadow: 2px 4px 4px ${({ theme }) => theme.color.almostBlack};
        border-right: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
      `}

	`};
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
  > a {
    width: ${({ isSticky }) => (isSticky ? 95 : 116)}px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    > b {
      color: ${({ theme }) => theme.color.brand01};
      display: block;
    }
    > span {
      ${({ theme }) => theme.typography.tiny}
      ${Ellipsis}
      min-height: 16px;
      ${media.mdDown`
        min-height: 14px;
      `}
    }
  }
`;

export const IndustryColumn = styled('td')`
  color: ${({ theme }) => theme.color.brand01};
  > a {
    width: 140px;
    > span {
      ${Ellipsis}
    }
  }
`;

export const WatchlistColumn = styled('td')`
  width: 46px;
`;

export const PELabel = styled('span')`
  ${({ theme }) => theme.typography.tiny}
  && {
    width: auto;
    display: inline-block;
  }
  margin-right: 4px;
  white-space: nowrap;
  color: inherit;
  border-bottom: 1px dotted ${({ theme }) => theme.color.brand01};
  cursor: pointer;
  display: inline-block;
  background-color: ${({ theme }) => theme.color.brand01RGBA(0.1)};
  user-select: none;
`;

export const CompanyName = styled('span')`
  ${({ theme }) => theme.typography.tiny}
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  user-select: none;
  && {
    width: auto;
    max-width: 100%;
  }
  border-bottom: 1px dotted ${({ theme }) => theme.color.brand01};
`;

export const ToolTipText = styled('span')`
  display: inline-block;
  max-width: 200px;
`;

export const ScrollPane = styled('div')`
  overflow-x: auto;
  > table {
    min-width: 920px;
  }
`;

export const ValueColumn = styled('td')<{
  value: null | number;
}>`
  color: ${({ value, theme }) =>
    theme.color.whiteRGBA(value === null ? 0.3 : 1)};
`;

export const SnowflakeBone = styled('span')`
  background: ${({ theme }) => theme.color.whiteRGBA(0.1)};
  width: 48px;
  height: 48px;
  border-radius: 48px;
  margin-left: ${({ theme }) => theme.x1spacePx}px;
`;

export const NoResults = styled('td')`
  text-align: center !important;
  padding: ${({ theme }) => theme.x5spacePx}px 0 !important;
  border-bottom: none !important;
  ${({ theme }) => theme.typography.xSmall};
  opacity: 0.3;
`;

export const ValuationRatioWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  max-width: 255px;
  > span {
    padding: 0 ${({ theme }) => theme.x1spacePx}px;
    padding-top: ${({ theme }) => theme.x1spacePx}px;
  }
`;

export const ValuationItemLabel = styled('div')`
  ${({ theme }) => theme.typography.xSmallStrong}
  color: ${({ theme }) => theme.color.spaceGray};
  > strong {
    ${({ theme }) => theme.typography.xLargeStrong}
  }
  > span {
    opacity: 0.3;
    padding-left: 4px;
  }
`;

export const ValuationItemText = styled('div')`
  ${({ theme }) => theme.typography.tiny}
  opacity: 0.5;
`;

export const ValuationItemWrapper = styled('div')`
  padding: ${({ theme }) => theme.x1spacePx}px;
`;
